<template>
  <div style="background: rgb(244, 244, 244); min-height: 80vh">
    <div class="goodsbox">
      <Loading v-if="loading"></Loading>
      <div class="main" v-else>
        <div class="goods_left">
          <Carousel loop autoplay v-if="shopInfo.carousel.length > 1">
            <CarouselItem v-for="item in shopInfo.carousel" :key="item.id">
              <img :src="item" alt="" />
            </CarouselItem>
          </Carousel>
          <img :src="shopInfo.front" class="goods_img" alt v-else />
        </div>
        <div class="goods_right">
          <p class="goods_name">{{ shopInfo.name }}</p>

          <div class="tm-fcs-panel">
            <div class="goods_nav">
              <div class="dt">价格：</div>
              <div class="dd price" :style="discountOn ? 'color:#999' : ''">
                <em style="font-size: 14px">￥</em>{{ norms.price }}
              </div>
            </div>
            <div class="goods_nav" v-show="discountOn">
              <div class="dt">折扣价：</div>
              <div class="dd discount">
                <em style="font-size: 14px">￥</em
                >{{
                  discountOn
                    ? (norms.price * (discount.discount / 100)).toFixed(2)
                    : norms.price
                }}
                <em class="promo-type"><s></s>狂欢不止</em>
                <span class="end-name"
                  >距结束
                  <span :endTime="endTime" :endText="endText" id="timer">
                    <slot>{{ content }}</slot>
                  </span>
                </span>
              </div>
            </div>

            <div class="des">
              {{ shopInfo.synopsis }}
            </div>
            <div class="sales">
              已售：{{ shopInfo.sales }} {{ shopInfo.unit }}
            </div>
          </div>

          <div class="goods_nav">
            <div class="dt">库存：</div>
            <div class="dd" v-if="shopInfo.stocktype == 1">
              {{ norms.stock }} {{ shopInfo.unit }}
            </div>
            <div class="dd" v-if="shopInfo.stocktype == 2">
              {{ norms.stock > 0 ? "充足" : "不足" }}
            </div>
          </div>
          <div class="goods_nav" v-if="shopInfo.serve.length > 0">
            <div class="dt">服务：</div>
            <div class="dd">
              <Tag
                v-for="(item, index) in shopInfo.serve"
                :key="item"
                :color="color[index]"
                >{{ item }}</Tag
              >
            </div>
          </div>

          <div class="goods_nav">
            <div class="dt">规格：</div>
            <div class="dd">
              <span
                class="norms"
                v-for="item in shopInfo.list"
                :key="item.id"
                @click="norms = item"
                :class="norms.id == item.id ? 'active' : ''"
                >{{ item.name }}</span
              >
            </div>
          </div>
          <div class="goods_nav">
            <div class="dt">数量：</div>
            <div class="dd">
              <InputNumber
                v-model="count"
                :step="1"
                :min="1"
                :max="norms.maxbuy == 0 ? 9999 : norms.maxbuy"
              >
              </InputNumber>
            </div>
          </div>
          <div class="goods_nav">
            <a
              href="javascript:;"
              title="点击此按钮，到下一步确认购买信息。"
              @click="norms.stock != 0 ? goBuy() : ''"
            >
              {{ norms.stock == 0 ? "库存不足" : "立即购买" }}
            </a>
          </div>
        </div>
        <div class="goods_bottom">
          <div class="bottom_title">
            <span class="iconfont icon-jieshao"></span>
            <span style="font-weight: 600">商品介绍</span>
          </div>
          <div class="bg_content" v-html="shopInfo.details"></div>
        </div>
      </div>
    </div>
    <Modal
      v-model="model"
      width="600"
      ref="create"
      title="订单确认"
      footer-hide
    >
      <Form ref="create" :model="createData" :label-width="100">
        <FormItem label="订单规格：">
          <span>
            {{ norms.name }}
          </span>
        </FormItem>
        <FormItem label="购买数量：">
          <span> {{ count }} {{ shopInfo.unit }} </span>
        </FormItem>
        <FormItem label="订单金额：">
          <span class="model-price">
            {{ price }}
          </span>
        </FormItem>
        <FormItem label="手机号：" style="margin-bottom: 0">
          <Input
            v-model="createData.phone"
            placeholder="请输入手机号"
            style="width: 300px"
          />
        </FormItem>
        <FormItem style="margin-bottom: 0" v-show="shopInfo.deliver_phone">
          <Checkbox v-model="createData.sendPhone"
            >发送到我手机 ({{
              shopInfo.deliver_phone_price == 0
                ? "免费"
                : shopInfo.deliver_phone_price + "元"
            }})
          </Checkbox>
        </FormItem>
        <FormItem
          label="邮箱："
          style="margin-bottom: 0"
          v-show="createData.sendEmail"
        >
          <Input
            v-model="createData.email"
            placeholder="请输入邮箱"
            style="width: 300px"
          />
        </FormItem>
        <FormItem v-show="shopInfo.deliver_email == 1">
          <Checkbox v-model="createData.sendEmail"
            >发送到我邮箱(免费)
          </Checkbox>
        </FormItem>
        <FormItem label="备注：" style="margin-top: 10px">
          <Input
            v-model="createData.remarks"
            type="textarea"
            :rows="3"
            placeholder="选填"
            style="width: 300px"
          />
        </FormItem>

        <FormItem style="margin-bottom: 30px">
          <Button
            type="primary"
            @click="submit('alipay')"
            :disabled="basic.alipay_type == 0 ? true : false"
            >支付宝支付</Button
          >
          <Button
            type="success"
            style="margin-left: 10px"
            @click="submit('wxpay')"
            :disabled="basic.wxpay_type == 0 ? true : false"
            >微信支付</Button
          >
          <Button style="margin-left: 10px" @click="model = false"
            >再逛逛</Button
          >
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { getSingleShop, postPay, getDiscount, postSubmit } from "@/api/index";
import { mapState } from "vuex";
import cookie from "@/utils/store/cookie";
export default {
  data() {
    return {
      createData: {
        phone: "",
        email: "",
        remarks: "",
        sendPhone: false,
        sendEmail: false,
      },
      loading: true,
      model: false,
      shopInfo: [],
      mask: false,
      current: 0,
      count: 1,
      color: window.config.serve_color,
      norms: {},
      discount: {},
      discountOn: false,
      content: "",
      price: "",
      creating: false,
    };
  },
  props: {
    endTime: {
      type: String,
      default: "",
    },
    endText: {
      type: String,
      default: "活动已结束",
    },
  },
  created() {
    this._getSingleShop(this.$route.params.id);
  },

  computed: {
    ...mapState(["basic"]),
    sendPhone() {
      return this.createData.sendPhone;
    },
  },
  watch: {
    sendPhone(newVal) {
      if (newVal) {
        this.price = (
          Number(this.price) + Number(this.shopInfo.deliver_phone_price)
        ).toFixed(2);
      } else {
        this.price = this.discountOn
          ? (this.norms.price * (this.discount.discount / 100)).toFixed(2)
          : this.norms.price.toFixed(2);
      }
    },
    // 监听路由刷新
    $route: {
      handler: function (val, oldVal) {
        window.location.reload();
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    //  点击购买
    goBuy() {
      let money = this.discountOn
        ? this.norms.price * (this.discount.discount / 100)
        : this.norms.price;
      this.price = (money * this.count).toFixed(2);
      this.model = true;
      this.$store.state.order = {
        goods_id: this.shopInfo.id,
        norms_id: this.norms.id,
        count: this.count,
        money: (money * this.count).toFixed(2),
      };
    },
    // 提交支付
    submit(payment) {
      if (
        !this.createData.phone ||
        !/^1[3456789]\d{9}$/.test(this.createData.phone)
      ) {
        return this.$Message.warning({
          background: true,
          content: "请输入正确的手机号",
        });
      }
      if (this.createData.sendEmail) {
        if (
          !this.createData.email ||
          !/^[0-9a-z]\w+[0-9a-z]@\w{2,}\.(com|cn|edu|org|net|cc|vip|top)$/.test(
            this.createData.email
          )
        ) {
          return this.$Message.warning({
            background: true,
            content: "请输入正确的邮箱",
          });
        }
      }
      this.$Message.loading({
        content: "正在创建订单...",
        duration: 2,
      });
      cookie.set("phone", this.createData.phone, 30);

      postSubmit({
        norms_id: this.$store.state.order.norms_id,
        count: this.$store.state.order.count,
        payment: payment,
        send: this.createData.sendPhone ? 1 : 0,
        phone: this.createData.phone,
        email: this.createData.email,
        remarks: this.createData.remarks,
      }).then((res) => {
        if (res.code == 200) {
          if (payment == "alipay") {
            if (this.basic.alipay_type == 1 || this.basic.alipay_type == 4) {
              this._postPay(res.data);
            } else if (this.basic.alipay_type == 2) {
              this.$router.push("/codepay/" + res.data);
            } else if (this.basic.alipay_type == 3) {
              this.$router.push("/f2fpay/" + res.data);
            } else if (this.basic.alipay_type == 5) {
              this.$router.push("/geekpay/" + res.data);
            }
          } else {
            if (this.basic.wxpay_type == 1) {
              this.$router.push("/wxpay/" + res.data);
            } else if (this.basic.wxpay_type == 2) {
              this.$router.push("/codepay/" + res.data);
            } else if (this.basic.wxpay_type == 4) {
              this._postPay(res.data);
            } else if (this.basic.wxpay_type == 5) {
              this.$router.push("/geekpay/" + res.data);
            }
          }
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    // 提交支付宝支付
    _postPay(out_trade_no) {
      this.$Message.loading({
        content: "正在跳转支付...",
        duration: 2,
      });
      postPay({
        out_trade_no: out_trade_no,
      }).then((res) => {
        if (res.code == 200) {
          const form = res.data;
          const div = document.createElement("div");
          div.innerHTML = form;
          document.body.append(div);
          document.forms["alipaysubmit"].submit();
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    // 获取商品
    _getSingleShop(id) {
      getSingleShop({
        id,
      }).then((res) => {
        if (res.code == 200) {
          this.shopInfo = res.data;
          this.shopInfo.carousel.unshift(this.shopInfo.front);
          this.norms = res.data.list[0];
          if (res.data.salesId) {
            this._getDiscount(res.data.salesId);
          }
          this.loading = false;
        } else {
          this.$Message.error({
            background: true,
            content: res.msg,
          });
          this.$router.push("/");
        }
      });
    },
    // 获取折扣信息
    _getDiscount(id) {
      getDiscount({
        id,
      }).then((res) => {
        if (res.code == 200) {
          this.discount = res.data;
          // 转换时间戳
          let end = this.datetime_to_unix(res.data.endtime);
          let timestamp = Date.parse(new Date());
          let sta = this.datetime_to_unix(res.data.starttime);

          if (end > timestamp && sta < timestamp) {
            this.discountOn = true;
            this.countdowm(end);
          }
        }
      });
    },
    datetime_to_unix(datetime) {
      var tmp_datetime = datetime.replace(/:/g, "-");
      tmp_datetime = tmp_datetime.replace(/ /g, "-");
      var arr = tmp_datetime.split("-");
      var now = new Date(
        Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5])
      );
      return parseInt(now.getTime());
    },

    //计算时间
    countdowm(timestamp) {
      let self = this;
      let timer = setInterval(function () {
        let nowTime = new Date();
        let endTime = new Date(timestamp);
        let t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          let day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          let format = "";
          if (day > 0) {
            format = `${day}:${hour}:${min}:${sec}`;
          }
          if (day <= 0 && hour > 0) {
            format = `${hour}:${min}:${sec}`;
          }
          if (day <= 0 && hour <= 0) {
            format = `${min}:${sec}`;
          }
          self.content = format;
        } else {
          clearInterval(timer);
          self.content = self.endText;
          this.discountOn = false;
          self._callback();
        }
      }, 1000);
    },
    _callback() {
      if (this.callback && this.callback instanceof Function) {
        this.callback(...this);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/css/clean.css";
@deep: ~">>>";

.goodsbox {
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 1230px;
  background: #ffffff;

  .main {
    margin: 0 auto;
    padding: 20px 15px;
    width: 100%;
    max-width: 1230px;
    overflow: hidden;

    .goods_left {
      float: left;
      width: 40%;
      height: 420px;
      border: solid 1px #eee;
      position: relative;

      @{deep}.ivu-carousel-item {
        height: 418px !important;
      }

      img {
        width: 100%;
        height: 100%;
      }

      .cuxiao {
        position: absolute;
        width: 100%;
        bottom: 0px;
        height: 80px;
        // background: rgba(53, 47, 47, 0.8);
        background: linear-gradient(to right, #5769f9, #d658fe);

        .tempbg {
          position: relative;
          height: 80px;

          #timer {
            position: absolute;
            left: 10px;
            bottom: 10px;
            color: #fff;
            font-size: 22px;
          }

          .cuxiaosm {
            position: absolute;
            top: 10px;
            left: 10px;
            color: #fff;
            font-size: 18px;
          }

          .daoshou {
            position: absolute;
            right: 20px;
            bottom: 10px;
            font-size: 38px;
            color: red;
          }
        }
      }

      .goods_img {
        width: 100%;
        height: 420px;
        display: block;
        border-radius: 2px;
      }
    }

    .goods_right {
      float: left;
      margin-left: 2%;
      width: 58%;
      max-width: 760px;
      padding-right: 10px;

      .goods_name {
        font-size: 20px;
        color: #000000;
        margin: 10px 0;
        padding-left: 10px;
      }

      .tm-fcs-panel {
        background-color: #f4f4f4;
        position: relative;
        left: 0;
        z-index: 10;
        border-radius: 3px;
        padding-left: 5px;
        padding-bottom: 5px;
        padding-top: 5px;
        margin-bottom: 5px;

        .sales {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 14px;
          color: #999;
        }

        .goods_nav {
          margin-bottom: 10px;

          .price {
            color: red;
            font-size: 22px;
            text-align: left;
          }

          .discount {
            color: red;
            font-size: 30px;
            text-align: left;
            font-weight: bolder;
            font-family: Arial;

            .promo-type {
              background-color: #f47a86;
              border-radius: 1px;
              color: #fff;
              height: 16px;
              font-size: 12px;
              font-weight: normal;
              line-height: 16px;
              margin: 0 2px 4px 6px;
              padding: 1px 5px;
              position: relative;

              s {
                position: absolute;
                width: 0;
                display: block;
                font-size: 0;
                left: -4px;
                bottom: 0;
                height: 0;
                border: 3px solid #f47a86;
                border-color: transparent #f47a86 #f47a86 transparent;
              }
            }

            .end-name {
              margin-left: 50px;
              font-size: 18px;
            }
          }

          .dt {
            float: left;
            font-size: 14px;
            color: #999;
            line-height: 30px;
          }

          .dd {
            line-height: 30px;
            margin-left: 50px;
          }
        }
      }

      .des {
        width: 90%;
        color: #999;
        background-color: #f4f4f4;
        font-size: 14px;
        border-radius: 2px;
        margin: 5px 0;
        padding-left: 8px;
      }

      .goods_nav {
        margin-bottom: 10px;

        a {
          margin-top: 20px;
          margin-left: 50px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          font-size: 16px;
          margin-right: 0;
          float: left;
          overflow: hidden;
          position: relative;
          width: 178px;
          background-color: #ffeded;
          border: 1px solid #ff0036;
          color: #ff0036;
          font-family: "Microsoft Yahei";
        }

        .price {
          color: red;
          font-size: 22px;
          text-align: left;
        }

        .dt {
          float: left;
          font-size: 14px;
          color: #999;
          line-height: 30px;
          padding-left: 10px;
        }

        .dd {
          line-height: 30px;
          margin-left: 50px;

          .norms {
            display: inline-block;
            border: solid 1px #ccc;
            border-radius: 2px;
            font-size: 12px;
            padding: 0 12px;
            height: 30px;
            line-height: 30px;
            font-style: normal;
            margin-right: 10px;
            margin-bottom: 10px;
            cursor: pointer;
          }

          .active {
            border-color: #ff4500;
            color: #ff4500;
          }
        }
      }
    }

    .goods_bottom {
      float: left;
      width: 100%;
      margin-top: 60px;
      border: 1px solid #dfdfdf;

      .bottom_title {
        color: #000000;
        border-bottom: 1px solid #dfdfdf;
        padding: 10px 1%;
        font-size: 14px;

        .iconfont {
          font-size: 16px;
          // margin-bottom: 3px;
          margin-right: 5px;
        }
      }

      .bg_content {
        padding: 10px;
      }
    }
  }
}

.model-price {
  color: red;
  font-size: 24px;
  text-align: left;
  font-weight: bolder;
  font-family: Arial;
}

.ivu-form-item {
  margin-bottom: 15px;
}

@media screen and (max-width: 992px) {
}

/deep/table {
  font-size: 12px;
  color: #333333;
  width: 100%;
  border-width: 1px;
  border-radius: 3px;
  overflow: hidden;
  border-color: #ffffff;
  border-collapse: collapse;

  th {
    font-size: 12px;
    background-color: #ffffff;
    border-width: 1px;
    padding: 12px;
    text-align: center !important;
    border-style: solid;
    border-color: #e6e7e9;
    text-align: left;
  }

  tr {
    background-color: #ffffff;
  }

  td {
    // font-size: 12px;
    border-width: 1px;
    padding: 12px;
    text-align: center;
    border-style: solid;
    border-color: #e6e7e9;
  }
}
</style>